module.exports = __webpack_public_path__ + "static/media/logo.adc44f44.png";